import _ from "lodash";
import 'CssFolder/voc-widgets.scss';

export default function VocWidgetComponent() {
  let filterable = false;
  let onClick = () => { };
  let selectedFilter = '';

  let filter = (e) => {
    e.stopPropagation();
    selectedFilter = e.currentTarget.dataset.vocFilter;
    onClick(selectedFilter);
  }

  return {
    oninit: (vnode) => {
      if (vnode.attrs.onClick) {
        filterable = true;
        onClick = vnode.attrs.onClick;
      }
      if (typeof vnode.attrs.selectedFilter === 'string') {
        selectedFilter = vnode.attrs.selectedFilter;
      }
    },
    onupdate: (vnode) => {
      if (typeof vnode.attrs.selectedFilter === 'string') {
        selectedFilter = vnode.attrs.selectedFilter;
      }
    },
    view: ({ attrs }) => {
      return [
        m('.voc-widget.widget-component', { class: filterable ? 'voc-filter' : '' },
          m('.voc-status-group',
            m('.voc-status-primary.voc-total[data-voc-filter]', { class: selectedFilter === '' ? 'selected' : '', onclick: filter },
              m('.title', 'Total', m('span.ms-1', '(cases)')),
              m('.count', attrs.data?.total ?? '-')
            ),
          ),
          m('.d-flex.flex-wrap.flex-grow-1.gap-2',
            m('.voc-status-group.flex-grow-1',
              m('.voc-status-primary.voc-pending[data-voc-filter="Pending"]', {
                class: selectedFilter === 'Pending' ? 'selected' : '',
                onclick: filter
              },
                m('.title', 'Pending', m('span.ms-1', '(cases)')),
                m('.count', attrs.data?.pending ?? '-')
              ),
              m('.voc-status-secondary.danger[data-voc-filter="Pending^Not Started"]', {
                class: selectedFilter === 'Pending^Not Started' ? 'selected' : '',
                onclick: filter
              },
                m('.title', 'Not Started', m('span.ms-1', '(cases)')),
                m('.count', attrs.data?.notStarted ?? '-')
              ),
              m('.voc-status-secondary[data-voc-filter="Pending^In Progress"]', {
                class: selectedFilter === 'Pending^In Progress' ? 'selected' : '',
                onclick: filter
              },
                m('.title', 'In Progress'),
                m('.d-flex.flex-grow-1.gap-1',
                  m('.period[data-voc-filter="Pending^In Progress^<1W"]', {
                    class: selectedFilter === 'Pending^In Progress^<1W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '<1W'),
                    m('.count', attrs.data?.ipLessThan1W ?? '-')
                  ),
                  m('.period[data-voc-filter="Pending^In Progress^<2W"]', {
                    class: selectedFilter === 'Pending^In Progress^<2W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '<2W'),
                    m('.count', attrs.data?.ipLessThan2W ?? '-')
                  ),
                  m('.period.danger[data-voc-filter="Pending^In Progress^<3W"]', {
                    class: selectedFilter === 'Pending^In Progress^<3W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '<3W'),
                    m('.count', attrs.data?.ipLessThan3W ?? '-')
                  ),
                  m('.period.danger[data-voc-filter="Pending^In Progress^>=3W"]', {
                    class: selectedFilter === 'Pending^In Progress^>=3W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '>=3W'),
                    m('.count', attrs.data?.ipMoreThanEqual3W ?? '-')
                  )
                )
              )
            ),
            m('.voc-status-group.flex-grow-1',
              m('.voc-status-primary.voc-resolved[data-voc-filter="Resolved"]', {
                class: selectedFilter === 'Resolved' ? 'selected' : '',
                onclick: filter
              },
                m('.title', 'Resolved', m('span.ms-1', '(cases)')),
                m('.count', attrs.data?.resolved ?? '-')
              ),
              m('.voc-status-secondary',
                m('.title', 'Average Day'),
                m('.count', attrs.data?.averageDays ?? '-')
              ),
              m('.voc-status-secondary',
                m('.title', 'Longest Day'),
                m('.count', attrs.data?.longestDays ?? '-')
              ),
              m('.voc-status-secondary',
                m('.title', 'Age'),
                m('.d-flex.flex-grow-1.gap-1',
                  m('.period[data-voc-filter="Resolved^^<1W"]', {
                    class: selectedFilter === 'Resolved^^<1W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '<1W'),
                    m('.count', attrs.data?.lessThan1W ?? '-')
                  ),
                  m('.period[data-voc-filter="Resolved^^<2W"]', {
                    class: selectedFilter === 'Resolved^^<2W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '<2W'),
                    m('.count', attrs.data?.lessThan2W ?? '-')
                  ),
                  m('.period.danger[data-voc-filter="Resolved^^<3W"]', {
                    class: selectedFilter === 'Resolved^^<3W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '<3W'),
                    m('.count', attrs.data?.lessThan3W ?? '-')
                  ),
                  m('.period.danger[data-voc-filter="Resolved^^>=3W"]', {
                    class: selectedFilter === 'Resolved^^>=3W' ? 'selected' : '',
                    onclick: filter
                  },
                    m('.subtitle', '>=3W'),
                    m('.count', attrs.data?.moreThanEqual3W ?? '-')
                  )
                )
              )
            )
          ),
        ),
      ]
    }
  }
}
